// ponytail: same tab logic as lead-form-radio-switcher.js. Two copies is fine;
// extract a shared aria-tabs module when a third block needs it.

import '@styles/blocks/acf-blocks/_visual-search-showcase.scss';

// Panels slide left to right: the incoming one travels in from the left while the
// outgoing one carries on out to the right. CSS owns the timing; `is-leaving` is
// cleared once the transition ends so the panel returns to its waiting position.
function selectTab(tabs, panels, index) {
  tabs.forEach((tab, tabIndex) => {
    const isSelected = tabIndex === index;
    const panel = panels[tabIndex];
    const wasSelected = panel.classList.contains('is-active');

    tab.setAttribute('aria-selected', String(isSelected));
    tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    panel.classList.toggle('is-active', isSelected);

    if (isSelected) {
      panel.classList.remove('is-leaving');
      return;
    }

    // A panel hidden by visibility is still playing, so stop it on the way out.
    panel.querySelectorAll('video').forEach((video) => video.pause());

    if (wasSelected) {
      panel.classList.add('is-leaving');
      panel.addEventListener(
        'transitionend',
        () => panel.classList.remove('is-leaving'),
        { once: true },
      );
    }
  });
}

// Scrolls the tab strip itself (not the page) so the active tab is fully in view.
function scrollTabIntoView(tab) {
  const strip = tab.parentElement;

  if (strip.scrollWidth <= strip.clientWidth) {
    return;
  }

  const left = tab.offsetLeft - (strip.clientWidth - tab.offsetWidth) / 2;
  strip.scrollTo({ left, behavior: 'smooth' });
}

function initShowcase(showcase) {
  const tabs = Array.from(showcase.querySelectorAll('[data-visual-search-showcase-tab]'));
  const panels = tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));

  if (!tabs.length) {
    return;
  }

  // The markup ships with `hidden` on the inactive panels so a no-JS page still
  // shows only the first one. From here the classes drive visibility instead.
  panels.forEach((panel) => { panel.hidden = false; });

  const alreadySelected = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
  selectTab(tabs, panels, alreadySelected === -1 ? 0 : alreadySelected);

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      selectTab(tabs, panels, index);
      scrollTabIntoView(tab);
    });

    tab.addEventListener('keydown', (event) => {
      const keyToIndex = {
        ArrowRight: (index + 1) % tabs.length,
        ArrowDown: (index + 1) % tabs.length,
        ArrowLeft: (index - 1 + tabs.length) % tabs.length,
        ArrowUp: (index - 1 + tabs.length) % tabs.length,
        Home: 0,
        End: tabs.length - 1,
      };
      const nextIndex = keyToIndex[event.key];

      if (nextIndex === undefined) {
        return;
      }

      event.preventDefault();
      selectTab(tabs, panels, nextIndex);
      tabs[nextIndex].focus();
      scrollTabIntoView(tabs[nextIndex]);
    });
  });
}

document.querySelectorAll('[data-visual-search-showcase]').forEach(initShowcase);
